import { render } from "./PLNavigationDrawer.vue?vue&type=template&id=7907567b&scoped=true"
import script from "./PLNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./PLNavigationDrawer.vue?vue&type=script&lang=js"

import "./PLNavigationDrawer.vue?vue&type=style&index=0&id=7907567b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7907567b"]])

export default __exports__